import { apiAgent } from "../../../axiosConfig"
import getApiUrl from "../../utils/UrlHelper"

export const remove_past_education = (data_params) => {
    return apiAgent({
        method: "post",
        url: getApiUrl('remove_past_education'),
        data: data_params
    })
}

export const fetchProspectTrackingSettings = (data_params) => {
    return apiAgent({
        method: "get",
        url: getApiUrl('get_prospect_tracking_settings', {":id": data_params.id}),
        data: data_params
    })
}

export const updateProspectTrackingSettings = (data_params) => {
    return apiAgent({
        method: "post",
        url: getApiUrl('update_prospect_tracking_settings', {":id": data_params.id}),
        data: data_params
    })
}

export const toggleNewsQueryTracking = (data_params) => {
    return apiAgent({
        method: "post",
        url: getApiUrl('toggle_news_query', {":id": data_params.id}),
        data: data_params
    })
}

export const windfall_profile = (data_params) => {
    return apiAgent({
        method: "get",
        url: getApiUrl('windfall_profile'),
        params: data_params
    })
}